import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { Payment, Transaction } from 'src/app/models';
import { CopyToClipboardComponent } from 'src/app/shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { BANK_IDS, COMMERCIAL_NETWORKS_IDS } from '../../core/constants/payMethods-cr';
import { BANK_GU_IDS } from 'src/app/core/constants/payMethods-gu';
import { environment } from 'src/environments/environment';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { FLAGS_NAME, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';

@Component({
    selector: 'app-efectivo',
    templateUrl: './efectivo.component.html',
    styleUrls: ['./efectivo.component.scss'],
})
export class EfectivoComponent implements OnInit {
    @Input() info: Payment;
    @Input() transaction: Transaction;
    @Input() currentConcept: any;
    @ViewChildren(CopyToClipboardComponent) copiesComponents: QueryList<CopyToClipboardComponent>;

    isMerchantCR = false;
    isMerchantGU: boolean = false;
    isBamPaymethod: boolean = false;
    isBiPaymethod: boolean = false;
    isHeyPayMethod: boolean = false;
    ref_bam: string = environment.ref_bam;
    downloadInstructionButtonFF: boolean = false;
    ptosHeyPdf = environment.ptosHeyLocationsPdf;
    ptosHeyPdfDownloadFF: boolean = false;

    constructor(private featureFlagService: PayvalidaFeatureFlagService) {}

    async ngOnInit() {
        this.isMerchantCR = this.isCR(this.info.originCode);
        this.isMerchantGU = this.isGU(this.info.originCode);
        this.isBamPaymethod = this.isBAM(this.info.originCode);
        this.isBiPaymethod = this.isBI(this.info.originCode);
        this.isHeyPayMethod = this.info.originCode === COMMERCIAL_NETWORKS_IDS.PUNTOS_HEY ? true : false;

        this.featureFlagService
            .getFeatureFlagValue(`networkCode_${this.info.code}`, FLAGS_NAME.DOWNLOAD_INSTRUCTIONS_BUTTON, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM)
            .subscribe((response: boolean) => {
                this.downloadInstructionButtonFF = response;
            });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.PUNTOS_HEY_PDF_DOWNLOAD, FLAGS_NAME.PUNTOS_HEY_PDF_DOWNLOAD, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM).subscribe((response: boolean) => {
            this.ptosHeyPdfDownloadFF = true;
        });
    }

    /**
     * @description returns if the commercial code belongs to those of costa rica
     */
    isCR(code: number) {
        return code === BANK_IDS.BNCR_PAY_WEB || code === BANK_IDS.BNCR_DEPOSIT || code === BANK_IDS.BNCR_TRANSFER || code === BANK_IDS.BCR_DEPOSIT || code === BANK_IDS.BCR_TRANSFER;
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala
     */
    isGU(code: number) {
        return (
            code === BANK_GU_IDS.BAM_CASH ||
            code === BANK_GU_IDS.BAM_DEPOSIT ||
            code === BANK_GU_IDS.BAM_TRANSFER ||
            code === BANK_GU_IDS.BI_DEPOSIT_B ||
            code === BANK_GU_IDS.BI_DEPOSIT ||
            code === BANK_GU_IDS.BI_TRANSFER
        );
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala BAM paymethods
     */
    isBAM(code: number) {
        return code === BANK_GU_IDS.BAM_CASH || code === BANK_GU_IDS.BAM_DEPOSIT || code === BANK_GU_IDS.BAM_TRANSFER;
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala BI paymethods
     */
    isBI(code: number) {
        return code === BANK_GU_IDS.BI_DEPOSIT_B || code === BANK_GU_IDS.BI_DEPOSIT || code === BANK_GU_IDS.BI_TRANSFER;
    }
}
